import React, { Component } from "react";

import Layout from "../layout";
import GeneralSection from "./GeneralSection";
import AboutBarnier from "./AboutLuc";
import AboutSylvie from "./AboutSylvie";

class index extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }
  render() {
    return (
      <Layout>
        <div style={{ marginTop: '10rem' }}>
          <GeneralSection />
          <AboutBarnier />
          <AboutSylvie />
        </div>
      </Layout>
    );
  }
}

export default index;
